<template>
  <div class="achievement-top-bar">
    <!-- 第一行-查询条件 -->
    <!-- 查询条件 -->
    <div class="select">
      <!-- 年级 -->
      <div class="select-item">
        <el-select v-model="searchInfo.gradeId" placeholder="选择年级">
          <el-option
            :label="item.gradeName"
            :value="item.gradeId"
            v-for="item in gradeList"
            :key="item.gradeId"
          ></el-option>
        </el-select>
      </div>
      <!-- 标题 -->
      <div class="select-item">
        <el-select v-model="searchInfo.title" placeholder="选择考试标题">
          <el-option
            :label="item"
            :value="item"
            v-for="(item, index) in examTitleList"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="select-item">
        <el-input
          v-model="searchInfo.subTitle"
          placeholder="请输入副标题"
        ></el-input>
      </div>
      <div class="select-item">
        <el-select v-model="searchInfo.examInfoId" placeholder="选择年级考试">
          <el-option
            :label="item.gradeName + '/' + item.title + '/' + item.subTitle"
            :value="item.id"
            v-for="(item, index) in gradeExamInfoList"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="select-item">
        <el-input
          v-model="searchInfo.outsideSchoolSign"
          placeholder="请输入校外标识"
        ></el-input>
      </div>
      <div class="select-btn">
        <!-- 搜索 -->
        <el-button
          type="primary"
          @click="search"
          round
          size="small"
          icon="el-icon-search"
        >
          搜索</el-button
        >
        <!-- 重置 -->
        <el-button
          @click="reset"
          round
          size="small"
          icon="el-icon-refresh
"
          >重置</el-button
        >
      </div>
    </div>
    <!-- 按钮列表 -->
    <div class="btn-list">
      <!-- 修改 -->
      <!-- <el-button type="primary" @click="editClick" round size="small">
        修改
      </el-button> -->
      <!-- 删除 -->
      <!-- <el-button type="danger" @click="deleteClick" round size="small">
        删除
      </el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["gradeList", "examTitleList", "gradeExamInfoList"],
  data() {
    return {
      // 搜索条件
      searchInfo: {
        title: "", // 主标题
        subTitle: "", // 副标题
        gradeId: "", // 年级
        outsideSchoolSign: "", // 校外标识
        examInfoId: "",
      },
    };
  },
  created() {},
  methods: {
    // 点击搜索
    search() {
      // console.log("this.searchInfo:", this.searchInfo);
      this.$emit("search", this.searchInfo);
    },
    // 点击重置
    reset() {
      this.searchInfo = {
        title: "", // 主标题
        subTitle: "", // 副标题
        gradeId: "", // 年级
        outsideSchoolSign: "", // 校外标识
        examInfoId: "",
      };
      this.$emit("search", this.searchInfo);
    },
    // 删除年级考试
    deleteClick() {
      this.$emit("deleteClick");
    },
    // 修改考试
    editClick() {
      this.$emit("editClick", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementTopBar.scss";
</style>
